import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { map } from 'lodash'
import { Box, Button, ButtonGroup } from '@material-ui/core'

import { actions } from 'store/calendar-visit-type-filter'

export const CalendarTypeFilters = ({ typeFilters, changeFilter }) => (
  <Box p={1}>
    <ButtonGroup size="small">
      {map(
        [
          ['In Person', 'ignore'],
          ['Virtual', 'only'],
        ],
        ([label, val]) => (
          <Button
            key={val}
            variant={typeFilters.virtual === val ? 'contained' : 'outlined'}
            color={typeFilters.virtual === val ? 'primary' : undefined}
            onClick={() => changeFilter({ name: 'virtual', value: typeFilters.virtual === val ? '' : val })}
          >
            {label}
          </Button>
        ),
      )}
    </ButtonGroup>
  </Box>
)

CalendarTypeFilters.propTypes = {
  typeFilters: PropTypes.object.isRequired,
  changeFilter: PropTypes.func.isRequired,
}

export default connect(
  (state) => ({
    typeFilters: state.calendarVisitTypeFilters,
  }),
  actions,
)(CalendarTypeFilters)
